import { SxProps, Theme } from "@mui/material";

export const availabilityCardStyles = {
  card: (theme: Theme): SxProps<Theme> => ({
    borderRadius: "10px",
    marginBottom: "20px",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    height: "95%",
    fontFamily: theme.typography.fontFamily,
  }),
  imageBox: {
    borderRadius: "8px",
    position: "relative",
  },
  image: {
    width: "100%",
    height: "175px",
    objectFit: "cover" as const,
    display: "block",
  },
  detailsBox: (theme: Theme) => ({
    padding: "10px 16px",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
    boxShadow: "0px 2px 7px 12px rgba(rgba(0,0,0,0.2))",
    flex: "1 1 auto",
    borderEndRadius: "9px",
    position: "relative",
    [theme.breakpoints.up("sm")]: {
      minHeight: "242px",
    },
  }),
  itemName: (theme: Theme): SxProps<Theme> => ({
    fontWeight: "600",
    fontSize: "20px",
    lineHeight: "26px",
    textAlign: "left",
    fontFamily: theme.typography.fontFamily,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  }),

  itemHeadline: (theme: Theme): SxProps<Theme> => ({
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    textAlign: "left",
    fontFamily: theme.typography.fontFamily,
  }),
  infoSection: (theme: Theme): SxProps<Theme> => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginTop: "5px",
    gap: "22px",
    [theme.breakpoints.down(350)]: {
      gap: "10px"
    },
  }),
  infoTypography: (theme: Theme): SxProps<Theme> => ({
    fontSize: "17px",
    color: "#0D0D0D",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontWeight: "600",
    fontFamily: theme.typography.fontFamily,
  }),

  timeSlotsContainer: {
    marginTop: "10px",
  },
  timeSlotsGrid: (theme: Theme): SxProps<Theme> => ({
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "12px",
    [theme.breakpoints.down(350)]: {
      gap: "7px"
    },
  }),
  timeSlotBox: (theme: Theme): SxProps<Theme> => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "8px 4px",
    border: "1px solid #e0e0e0",
    borderRadius: "10px",
    [theme.breakpoints.down(350)]: {
      padding: "8px",
    },
  }),
  timeSlotTime: (theme: Theme): SxProps<Theme> => ({
    fontWeight: "600",
    color: "#000",
    fontSize: "15px",
    flex: "1 0 0",
    whiteSpace: "nowrap",
    fontFamily: theme.typography.fontFamily,
    [theme.breakpoints.down(350)]: {
      fontSize: "13px",
    },
  }),
  timeSlotAvailability: {
    fontWeight: 400,
    color: "#000",
    fontSize: "11px",
    lineHeight: "20px",
  },
  moreTimesText: {
    color: "#0D0D0D",
    cursor: "pointer",
    marginTop: "10px",
    textAlign: "left",
    fontSize: "13px",
    fontWeight: 400,
  },
  bookNowText: (theme: Theme): SxProps<Theme> => ({
    width: "fit-content",
    margin: "0 auto",
    borderBottom: "1px solid green",
    position: "absolute",
    bottom: 15,
    left: 0,
    right: 0,
    fontSize: 15,
    fontWeight: "600",
    marginBottom: "-4px",
    fontFamily: theme.typography.fontFamily,
  }),
};
